import authDao from '../../../dao/authDao';
import {
  changeLanguage,
  setAccountSummary,
} from '../../../components/auth/reducers';
import {push} from 'react-router-redux';

const RESET = 'pages/auth/signup/RESET';
const SIGN_UP = 'pages/auth/signup/SIGN_UP';
const SIGN_UP_SUCCESS = 'pages/auth/signup/SIGN_UP_SUCCESS';
const SIGN_UP_FAIL = 'pages/auth/signup/SIGN_UP_FAIL';

const initialState = {
  error: '',
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case SIGN_UP:
      return {
        ...state,
        error: '',
      };
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        error: '',
      };
    case SIGN_UP_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export function reset() {
  return {type: RESET};
}

export function signUp(accountData) {
  return dispatch => {
    dispatch({type: SIGN_UP});

    return authDao
      .signUp(accountData)
      .then(json => dispatch(signUpSuccess(json)))
      .catch(error => dispatch(signUpFail(error)));
  };
}

function signUpSuccess(accountSummary) {
  return dispatch => {
    dispatch({type: SIGN_UP_SUCCESS});
    dispatch(setAccountSummary(accountSummary));
    dispatch(changeLanguage(accountSummary.account.languageType));
    dispatch(push({pathname: '/'}));
    return accountSummary;
  };
}

function signUpFail(error) {
  return dispatch => {
    dispatch({
      type: SIGN_UP_FAIL,
      error: error,
    });
    return Promise.reject(error);
  };
}
